import React, { useState, useEffect } from 'react';
import { Bug } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import FeedbackModal from './FeedbackModal';

const FeedbackButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Raccourci clavier CTRL+SHIFT+F
  useEffect(() => {
    const handleKeyDown = (event) => {
      // CTRL (ou CMD sur Mac) + SHIFT + F
      if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'F') {
        event.preventDefault();
        setIsModalOpen(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <>
      {/* Bouton flottant fixe */}
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              onClick={() => setIsModalOpen(true)}
              className="fixed bottom-6 right-6 z-40 rounded-full w-14 h-14 shadow-lg hover:shadow-xl transition-all hover:scale-110"
              size="icon"
              aria-label="Ouvrir le centre de feedback"
            >
              <Bug className="h-6 w-6" />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="left" className="font-medium">
            <p>Centre de Feedback</p>
            <p className="text-xs text-muted-foreground mt-1">
              Ctrl+Shift+F
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      {/* Modal de feedback */}
      <FeedbackModal open={isModalOpen} onOpenChange={setIsModalOpen} />
    </>
  );
};

export default FeedbackButton;
